export default __webpack_public_path__ + "static/media/Secure (2).ca13c8f2.png";